import { createAction, props } from '@ngrx/store';

// Import Records
export const importRecord = createAction(
    '[Data] Import record bulk import',
    props<{ newData: any }>()
);
export const importRecordSuccess = createAction(
    '[Data] Import record bulk import success'
);
export const importRecordFailure = createAction(
    '[Data] Import record bulk import failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state bulk import',
);